import { type JSX } from 'react';

import { css, cx } from '@emotion/css';
import { Col, Row, Space } from 'antd';
import { Link } from 'react-router-dom';
import { AlignItems, BorderRadius, Color, Display, Font, Spacing } from 'src/styles';

import { MSpinner } from '../MSpinner/MSpinner';

export const baseStyle = ({ isActive, isLoading }: { isActive: boolean; isLoading: boolean }) =>
  cx(
    Font.lg,
    Spacing.m4,
    Spacing.p16,
    Display.flex,
    AlignItems.center,
    BorderRadius.xs,
    css({
      fontWeight: isActive ? 'bold' : undefined,
      color: isActive ? Color.Brand6 : Color.Gray8,
      background: isActive ? Color.Brand2 : undefined,
      cursor: 'pointer',
      ':hover': {
        background: `${Color.Gray2} !important`,
      },
      justifyContent: isLoading ? 'center' : 'space-between',
    }),
  );

interface MenuItemLinkProps {
  name: string | JSX.Element;
  path?: string;
  isLoading?: boolean;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  onClick?: () => void;
  activatable?: boolean;
  className?: string;
}

export const MenuItem = ({
  name,
  path,
  isLoading = false,
  onClick,
  startIcon,
  endIcon,
  activatable = true,
  className,
}: MenuItemLinkProps) => {
  const isActive = path ? window.location.pathname.includes(path ?? '') && activatable : false;

  const renderContent = () => {
    if (isLoading) {
      return <MSpinner height='80' />;
    }

    return (
      <>
        <Row align='middle'>
          <Space direction='horizontal' size={16}>
            {startIcon && <Col>{startIcon}</Col>}
            <Col>{name}</Col>
          </Space>
        </Row>
        {endIcon && <Col className={Spacing.mr8}>{endIcon}</Col>}
      </>
    );
  };

  const _onClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (path) {
    return (
      <Link to={path} onClick={_onClick} className={cx(baseStyle({ isActive, isLoading }), className)}>
        {renderContent()}
      </Link>
    );
  }

  return (
    <Row onClick={onClick} className={cx(baseStyle({ isActive, isLoading }), className)}>
      {renderContent()}
    </Row>
  );
};
